import {getCookie} from '../app.js';
import {autosize} from "../app.js";

class LearnerGroup extends HTMLElement {
    constructor() {
        // Always call super first in the constructor
        super();
    }

    // Specify observed attributes for watching
    static get observedAttributes() {
        return ['id', 'json'];
    }

    // Lifecycle method called when the custom element is first connected to the document's DOM.
    connectedCallback() {
        var _self = this;
        var websiteurl = getCookie('WEBSITE_URL');
        const c_websiteurl = websiteurl;
        const c_id = this.id;

        function safeParse(data) {
            if (typeof data === 'string') { try { return JSON.parse(data); } catch(e) { return data; } }
            return data;
        }

        this.innerHTML = "<div id='learner-heading' style='padding: 8px 12px;'></div>" +
            "" +
            "  <div class='' id='container-fluid-groups'>" +
            "  </div>" +
            " <br /><br /><br />" +
            "<style>" +
            ".x-box-highlight {\n" +
            " background-color: #ffecb3 !important;\n" +
            "}\n" +
            ".x-box {\n" +
            " padding: 5px;\n" +
            "}\n" +
            ".x-box-1 {\n" +
            " padding: 5px;\n" +
            "}\n" +
            ".row {\n" +
            " padding: 10px !important;\n" +
            "}\n" +
            "\n" +
            ".over {\n" +
            "  border: 2px dashed #000;\n" +
            "}\n" +
            ".percentage-bar-outer {\n" +
            "  width: 100%; /* Full width of the container */\n" +
            "  background-color: #e0e0e0; /* Light grey background */\n" +
            "  border-radius: 5px; /* Optional: adds rounded corners */\n" +
            "  padding: 3px; /* Optional: adds some padding around the inner bar */\n" +
            "  margin-top: 10px;\n" +
            "}\n" +
            "\n" +
            ".percentage-bar-inner {\n" +
            "  height: 5px; /* Height of the percentage bar */\n" +
            "  background-color: #4db6ac; /* Color of the percentage bar */\n" +
            "  text-align: center; /* Aligns the text to the center */\n" +
            "  line-height: 20px; /* Centers the text vertically */\n" +
            "  color: white; /* Color of the text inside the bar */\n" +
            "  border-radius: 2px; /* Optional: adds rounded corners to the inner bar */\n" +
            "}\n"
        "</style>";

        function renderblock(json) {
            $.get(c_websiteurl + 'app.php/learners/nogrouplearners/?id=' + c_id)
                .done(function (data) {
                    var json = safeParse(data);

                    var learners_html = '';
                    json.forEach(function (learner) {
                        learners_html += '<div style="cursor:pointer;font-size:13px;" class="col-md-4 x-box-1 ' + (learner.id == c_id ? 'x-box-highlight' : '') + '" data-id="' + learner.id + '" draggable="true">' + (learner.gender == 'm' ? '<img style="height:20px;" src="' + c_websiteurl + '/img/male-student.png" />' : '<img style="height:20px;" src="' + c_websiteurl + '/img/female-student.png" />') + ' ' + learner.lastname + "," + learner.firstname + ' (' + learner.id + ')' + '</div>';
                    });

                    var html =
                        '<div class="panel panel-default" style="margin-bottom:12px;">' +
                        '  <div class="panel-heading" style="padding:10px 12px;">' +
                        '    <div style="font-size:14px;font-weight:600;"><strong>No Group</strong></div>' +
                        '  </div>' +
                        '  <div class="panel-body">' +
                        '  <div class="row">' +
                        learners_html +
                        '   </div>' +
                        '   </div>' +
                        '  <div class="panel-footer" id="panel-footer-nogroup" style="padding: 25px;">' +
                        '       <div>' +
                        "" +
                        '   </div>' +
                        '   </div>' +
                        '</div>'
                    '';
                    $("#container-fluid-groups").append(html);

                    $('.x-box-1').click(function () {
                        $.get(c_websiteurl + 'app.php/learners/learner/?id=' + $(this).data('id'))
                            .done(function (data) {
                                var json = safeParse(data);
                                var learner_html = '<img style="height: 16px; margin-top: -5px;" src="' + c_websiteurl + 'img/' + (json.gender && json.gender.toLowerCase().trim() == 'f' ? 'female-student.png' :  'male-student.png') + '" />&nbsp;' + json.lastname + ', ' + json.firstname
                                    + ' (<span class="text-primary">' + json.id + '</span>)'
                                    + '<br /><div><span style="font-size: 12px;" class="text-muted">Created: ' + json.created_formatted + ' (' + json.created_time_ago + ')</span>'
                                    + '<span style="font-size: 12px; padding-left: 20px;" class="text-muted">&nbsp;Last Update: ' + json.dateStamp_formatted + ' (' + json.dateStamp_time_ago + ')</span>'
                                    + '<br />' + json.tags + '</div>';

                                // Append contact info.
                                learner_html += '<table class="table table-bordered table-condensed" style="background: #ededed; width: 100%;">'
                                    + '<tr><td><strong>First Name:</strong></td><td>' + json.firstname + '</td>'
                                    + '<td><strong>Surname:</strong></td><td>' + json.lastname + '</td>'
                                    + '<td><strong>Gender:</strong></td><td>' + (json.gender && json.gender.toLowerCase() == 'm' ? 'Boy' : 'Girl') + '</td></tr>'
                                    + '<tr><td><strong>Date of Birth:</strong></td><td>' + json.birthDate + '</td>'
                                    + '<td><strong>Grade:</strong></td><td>' + json.grade + '</td>'
                                    + '<td><strong>Teacher:</strong></td><td>' + json.teachername + '</td></tr>'
                                    + '<tr><td><strong>Allergies:</strong></td><td>' + json.allergies + '</td>'
                                    + '<td><strong>Language</strong></td><td>' + (json.language == 'eng' ? 'English' : 'Afrikaans') + '</td>'
                                    + '<td><strong>Aftercare</strong></td><td>' + (json.aftercare == 1 ? 'Yes' : 'No') + '</td></tr>'
                                    + '<tr><td><strong>Mother:</strong></td><td>' + json.motherFirstname + ' ' + json.motherLastname  + '</td>'
                                    + '<td><strong>Mother Cell:</strong></td><td>' + json.motherCell + '</td>'
                                    + '<td><strong>Mother Email:</strong></td><td>' + json.motherEmail + '</td></tr>'
                                    + '<tr><td><strong>Father:</strong></td><td>' + json.fatherFirstname + ' ' + json.fatherLastname  + '</td>'
                                    + '<td><strong>Father Cell:</strong></td><td>' + json.fatherCell + '</td>'
                                    + '<td><strong>Father Email:</strong></td><td>' + json.fatherEmail + '</td></tr>'
                                    + '</table>';

                                learner_html += '<div style=""><button style="font-size: 10px;" class="btn btn-default btn-sm" onclick="document.getElementById(\'panel-footer-nogroup\').innerHTML = \'\';">CLOSE</button></div>';

                                $("#panel-footer-nogroup").html(learner_html);
                            });
                    });
                });

            $.get(c_websiteurl + 'app.php/learners/learnergroups/?id=' + c_id)
                .done(function (data) {

                    var json = safeParse(data);

                    json.forEach(function (group) {
                        var learners_html = '';
                        group.learners.forEach(function (learner) {
                            learners_html += '<div style="cursor:pointer;font-size:13px;" class="col-md-4 x-box ' + (learner.id == c_id ? 'x-box-highlight' : '') + '" data-id="' + learner.id + '" draggable="true">' + (learner.gender == 'm' ? '<img style="height:20px;" src="' + c_websiteurl + '/img/male-student.png" />' : '<img style="height:20px;" src="' + c_websiteurl + '/img/female-student.png" />') + ' ' + learner.lastname + ", " + learner.firstname + ' (' + learner.id + ')' + '</div>';
                        });

                        var html =
                            '<div class="panel panel-default" style="margin-bottom:12px;">' +
                            '  <div class="panel-heading" style="padding:10px 12px;">' +
                            '    <div style="font-size:14px;font-weight:600;white-space:pre;">' + group.name + '&nbsp;&nbsp;&nbsp;' + group.count + '/20 (' + group.allocation_percent + '%)&nbsp;&nbsp;&nbsp;' + group.allocatedUser + '&nbsp;&nbsp;&nbsp;<span class="badge bg-gray-lt text-gray">' + group.programName + '</span></div>' +
                            '<div class="percentage-bar-outer"><div class="percentage-bar-inner" style="width: ' + group.allocation_percent + '%;"></div></div>' +
                            '  </div>' +
                            '  <div class="panel-body">' +
                            '       <div class="row">' +
                            learners_html +
                            '   </div>' +
                            '   </div>' +
                            '  <div class="panel-footer" id="panel-footer-' + group.id + '" style="padding: 25px;">' +
                            '       <div>' +
                            "" +
                            '   </div>' +
                            '   </div>' +
                            '</div>'
                        ;
                        $("#container-fluid-groups").append(html);
                    });

                    $('.x-box').click(function () {
                        $.get(c_websiteurl + 'app.php/learners/learner/?id=' + $(this).data('id'))
                            .done(function (data) {
                                var json = safeParse(data);
                                var learner_html = '<img style="height: 16px; margin-top: -5px;" src="' + c_websiteurl + 'img/' + (json.gender && json.gender.toLowerCase().trim() == 'f' ? 'female-student.png' :  'male-student.png') + '" />&nbsp;' + json.lastname + ', ' + json.firstname
                                    + ' (<span class="text-primary">' + json.id + '</span>)'
                                    + '<br /><div><span style="font-size: 12px;" class="text-muted">Created: ' + json.created_formatted + ' (' + json.created_time_ago + ')</span>'
                                    + '<span style="font-size: 12px; padding-left: 20px;" class="text-muted">&nbsp;Last Update: ' + json.dateStamp_formatted + ' (' + json.dateStamp_time_ago + ')</span>'
                                    + '<br />' + json.tags + '</div>';

                                // Append contact info.
                                learner_html += '<table class="table table-bordered table-condensed" style="background: #ededed; width: 100%;">'
                                    + '<tr><td><strong>First Name:</strong></td><td>' + json.firstname + '</td>'
                                    + '<td><strong>Surname:</strong></td><td>' + json.lastname + '</td>'
                                    + '<td><strong>Gender:</strong></td><td>' + (json.gender && json.gender.toLowerCase() == 'm' ? 'Boy' : 'Girl') + '</td></tr>'
                                    + '<tr><td><strong>Date of Birth:</strong></td><td>' + json.birthDate + '</td>'
                                    + '<td><strong>Grade:</strong></td><td>' + json.grade + '</td>'
                                    + '<td><strong>Teacher:</strong></td><td>' + json.teachername + '</td></tr>'
                                    + '<tr><td><strong>Allergies:</strong></td><td>' + json.allergies + '</td>'
                                    + '<td><strong>Language</strong></td><td>' + (json.language == 'eng' ? 'English' : 'Afrikaans') + '</td>'
                                    + '<td><strong>Aftercare</strong></td><td>' + (json.aftercare == 1 ? 'Yes' : 'No') + '</td></tr>'
                                    + '<tr><td><strong>Mother:</strong></td><td>' + json.motherFirstname + ' ' + json.motherLastname  + '</td>'
                                    + '<td><strong>Mother Cell:</strong></td><td>' + json.motherCell + '</td>'
                                    + '<td><strong>Mother Email:</strong></td><td>' + json.motherEmail + '</td></tr>'
                                    + '<tr><td><strong>Father:</strong></td><td>' + json.fatherFirstname + ' ' + json.fatherLastname  + '</td>'
                                    + '<td><strong>Father Cell:</strong></td><td>' + json.fatherCell + '</td>'
                                    + '<td><strong>Father Email:</strong></td><td>' + json.fatherEmail + '</td></tr>'
                                    + '</table>';

                                learner_html += '<div style=""><button style="font-size: 10px;" class="btn btn-default btn-sm" onclick="document.getElementById(\'panel-footer-' + json.groupID + '\').innerHTML = \'\';">CLOSE</button></div>';

                                $("#panel-footer-" + json.groupID).html(learner_html);
                            });
                    });

                    // $(function () {
                    //     // Making divs with 'col-md-3' class draggable.
                    //     $(".x-box").draggable({
                    //         revert: "invalid", // If not dropped to a droppable area, the draggable will revert back to its original location
                    //         helper: "clone", // Clones the element while dragging
                    //         cursor: "move", // Changes the cursor shape while dragging
                    //         start: function (e, ui) {
                    //             $(ui.helper).addClass("ui-draggable-helper"); // Add class to the clone element during dragging
                    //         }
                    //     });
                    //
                    //     // Making bootstrap rows i.e '.row' class droppable.
                    //     $(".panel-body").droppable({
                    //         accept: ".col-md-4",
                    //         drop: function (event, ui) {
                    //             var newColumn = $(ui.helper).clone(); // Creating a clone of dragged element.
                    //             newColumn.removeClass("ui-draggable-helper"); // Remove the helper class
                    //             $(this).append(newColumn); // Adding the cloned element to the droppable.
                    //             console.log(newColumn);
                    //             ui.draggable.remove(); // Removing the original element
                    //         }
                    //     });
                    // });
                });

        }


        if (c_id > 0) {
            // Get the learner json.
            $.get(c_websiteurl + 'app.php/learners/learner/?id=' + c_id)
                .done(function (data) {
                    var json = safeParse(data);
                    _self.querySelector('#learner-heading').innerHTML = '<a class="btn btn-sm btn-outline-secondary" style="display:inline-flex;align-items:center;gap:6px;" target="_blank" href="' + c_websiteurl + 'app.php/learners/exportlearnergroups/?id=' + c_id + '"><img src="/img/tabler/file-spreadsheet.svg" style="height:14px;width:14px;"> Excel</a>';
                    renderblock(json);
                });
        }
    }
}

window.customElements.define('learner-group', LearnerGroup);
